export default values => {
  if (!values.name) return { name: 'Complete el nombre de la función' };
  else return {};
};
